import React from 'react';
import Alert from '../../../../shared/components/Alert/Alert';
import Typography from '../../../../shared/components/Typography/Typography';
import WikiArticleCard from './WikiArticleCard';
import { FolderIcon, HistoryIcon, StarIcon } from './WikiIcons';

function WikiCollectionPage({
  favorites = [],
  getCategoryLabel,
  onOpenArticle,
  onToggleFavorite,
  rows,
  title,
}) {
  const isFavorites = /favori/i.test(title);
  const isRecent = /récent|recent/i.test(title);
  const CollectionIcon = isFavorites ? StarIcon : isRecent ? HistoryIcon : FolderIcon;
  const iconTone = isFavorites ? 'pink' : isRecent ? 'blue' : 'pink';

  return (
    <div className="wiki-content-stack wiki-collection-page">
      <header className="wiki-collection-header">
        <span className={`wiki-collection-header__icon wiki-icon-tone--${iconTone}`} aria-hidden="true"><CollectionIcon /></span>
        <div><Typography variant="h5">{title}</Typography><p>{rows.length} article(s) dans cette vue documentaire.</p></div>
      </header>
      {rows.length ? (
        <div className="wiki-card-grid">
          {rows.map((article) => (
            <WikiArticleCard
              key={article.id}
              article={article}
              getCategoryLabel={getCategoryLabel}
              isFavorite={favorites.includes(article.id)}
              onOpen={onOpenArticle}
              onToggleFavorite={onToggleFavorite}
            />
          ))}
        </div>
      ) : (
        <Alert severity="info">Aucun article dans cette vue.</Alert>
      )}
    </div>
  );
}

export default WikiCollectionPage;
